import { Component, input, output } from '@angular/core';
import { InputFieldComponent } from '@zayan-erp/shared';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SigninFormValues } from '@zayan-erp/administration';
import { Button } from '@openng/optimus-ui/button';

@Component({
  selector: 'lib-signin-form',
  imports: [InputFieldComponent, FormsModule, ReactiveFormsModule, Button],
  standalone: true,
  templateUrl: './signin-form.component.html',
  styleUrl: './signin-form.component.scss'
})
export class SigninFormComponent {
  formValues = output<SigninFormValues>();
  isPasswordVisible: boolean = false;
  isLoading = input<boolean>();

  isCapsLockOn: boolean = false;

  onPasswordKeyEvent(event: KeyboardEvent): void {
    if (!event['getModifierState']) return;
    this.isCapsLockOn = event.getModifierState('CapsLock');
  }

  loginForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
    ]),
    password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(15)]),
    rememberMe: new FormControl(false)
  });

  submitLoginForm() {
    if (this.loginForm.valid) {
      this.formValues.emit(this.loginForm.value as SigninFormValues);
    }
  }
}
